/**
 * Generates an inverse mapping for an object.
 * Keys of the original object become values of the reversed object,
 * and values of the original object become keys of the reversed object.
 *
 * @template T - The type of the input object. It must be an object
 * whose keys are of type `string` and whose values are `string` or `number`.
 * @param obj - The object for which the inverse mapping is to be created.
 * @returns A new object with the typed inverse mapping.
 * The keys of this object will be the values of the original object,
 * and its values will be the keys of the original object.
 * If there are duplicate values in 'obj', the last key associated with that value
 * will prevail in the inverse mapping.
 */
export function getReversedMapping(obj) {
    const values = Object.values(obj);
    const uniqueValues = new Set(values);
    if (values.length !== uniqueValues.size) {
        console.warn("Warning: The input object has duplicate values. The reversed mapping might overwrite keys.");
    }
    const reversedEntries = Object.entries(obj).map(([key, value]) => [
        value,
        key,
    ]);
    return Object.fromEntries(reversedEntries);
}
